import React from 'react'
import CardUI from '../../widgets/layout/CardUI'
import FormSF from '../../widgets/form/FormSF'
import InputPhoneNumberUI from '../../widgets/form/InputPhoneNumberUI'
import './SignUp.css'

const PinCodeResetStep1UI = ({context, messageList, onSubmit, submitted, successMsg, errorList, setErrorList,
    // phone number
    phoneNumber, onPhoneNumberChange, phoneNumberError, setPhoneNumberError,
  }) =>
  <CardUI context={context}>
    <FormSF context={context} className='pub_signup' messageList={messageList} buttonMessageKey='c_continue'
        onSubmit={onSubmit} successMsg={successMsg} errorList={errorList} setErrorList={setErrorList}
        busy={submitted}>
      <InputPhoneNumberUI name='phoneNumber' required={true}
        messageList={messageList} labelKey='c_phone_number' helpKey='c_tip_pincode_reset'
        value={phoneNumber} onChange={onPhoneNumberChange}
        error={phoneNumberError} setError={setPhoneNumberError}
      />
    </FormSF>
  </CardUI>

export default PinCodeResetStep1UI
